import React, { useMemo } from "react";
import GameDesk from "../catalog_game/games-desk/GameDesk";
import "./favorites.scss";
import ShowContainer from "../../mui/ShowContainer";
import { getSliceForCarousel } from "../../../utils/utils";
import { useAppSelector } from "../../../store/index.ts";

export default function Favorites() {
  const favoritesS = useAppSelector((state) => state.games.favorites.list);
  const favorites = useMemo(() => getSliceForCarousel(favoritesS), [favoritesS]);
  const isAuth = useAppSelector((state) => state.user.isAuth);

  return (
    <ShowContainer condition={favorites.length && isAuth}>
      <section className="favorites">
        <div className="favorites__content">
          <GameDesk
            id={"favorites"}
            showAllLink={"/games/favorites"}
            title={"Favorites"}
            items={favorites}
          />
        </div>
      </section>
    </ShowContainer>
  );
}
